import { Box, Button, Stack, Typography } from "@mui/material";
import { FastField, useFormikContext } from "formik";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import OutlinedSelectButton from "../../../../Components/SelectionButton";
import { Collapse, Tag, Space, InputNumber } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { memo, useEffect, useRef, useState } from "react";
import CustomOptions from "../../../../Components/CustomOptionsButton";
import { enqueueSnackbar } from "notistack";

const ColumnsSettings = () => {

    const outletContext = useOutletContext();
    const { state } = useLocation();
    const { headerCorpId, reportConfiguration } = outletContext;
    const { values, handleChange, setFieldValue } = useFormikContext();
    const COLUMN_KEYS = [
        "firstColumn",
        "secondColumn",
        "thirdColumn",
        "fourthColumn",
    ];
    const GROUPS = {

        PTD: {
            firstColumn: "PTD",
            secondColumn: "PTDLY",
            thirdColumn: "PTDBudget",
            fourthColumn: "PTDForecast",
        },
        QTD: {
            firstColumn: "QTD",
            secondColumn: "QTDLY",
            thirdColumn: "QTDBudget",
            fourthColumn: "QTDForecast",
        },
        YTD: {
            firstColumn: "YTD",
            secondColumn: "YTDLY",
            thirdColumn: "YTDBudget",
            fourthColumn: "YTDForecast",
        },
        Current: {
            firstColumn: "Current",
            secondColumn: "CurrentLY",
            thirdColumn: "CurrentBudget",
            fourthColumn: "CurrentForecast",
        },
        Month: {
            firstColumn: "Month",
            secondColumn: "MonthLY",
            thirdColumn: "MonthBudget",
            fourthColumn: "MonthForecast",
        },
        Quarter: {
            firstColumn: "Quarter",
            secondColumn: "QuarterLY",
            thirdColumn: "QuarterBudget",
            fourthColumn: "QuarterForecast",
        },
        Year: {
            firstColumn: "Yearly",
            secondColumn: "YearlyLY",
            thirdColumn: "YearlyBudget",
            fourthColumn: "YearlyForecast",
        },
        DynamicMonth: {
            firstColumn: "DynamicMonth",
            secondColumn: "DynamicMonthLY",
            thirdColumn: "DynamicMonthBudget",
            fourthColumn: "DynamicMonthForecast",
        },
    };
    // const PARENT_CHILD_MAP = {
    //     "LY POR": [
    //         // "LY POR % Variance",
    //         // "LY POR % Variance $ Variance",
    //         "PTDLYPORPercVar",
    //         "QTDLYPORPercVar",
    //         "YTDLYPORPercVar",
    //         "CurrentLYPORPercVar",
    //         "MonthLYPORPercVar",
    //         "QuarterLYPORPercVar",
    //         "YearlyLYPORPercVar",
    //         "DynamicMonthLYPORPercVar",

    //         "PTDLYPORDollarVar",
    //         "QTDLYPORDollarVar",
    //         "YTDLYPORDollarVar",
    //         "CurrentLYPORDollarVar",
    //         "MonthLYPORDollarVar",
    //         "QuarterLYPORDollarVar",
    //         "YearlyLYPORDollarVar",
    //         "DynamicMonthLYPORDollarVar"

    //     ],
    //     "LY PAR": [
    //         // "LY PAR % Variance",
    //         // "LY PAR % Variance $ Variance",

    //         "PTDLYPARPercVar",
    //         "QTDLYPARPercVar",
    //         "YTDLYPARPercVar",
    //         "CurrentLYPARPercVar",
    //         "MonthLYPARPercVar",
    //         "QuarterLYPARPercVar",
    //         "YearlyLYPARPercVar",
    //         "DynamicMonthLYPARPercVar",

    //         "PTDLYPARDollarVar",
    //         "QTDLYPARDollarVar",
    //         "YTDLYPARDollarVar",
    //         "CurrentLYPARDollarVar",
    //         "MonthLYPARDollarVar",
    //         "QuarterLYPARDollarVar",
    //         "YearlyLYPARDollarVar",
    //         "DynamicMonthLYPARDollarVar"

    //     ],
    //     "Budget POR": [
    //         // "Budget POR % Variance",
    //         // "Budget POR % Variance $ Variance"
    //         "PTDBudgetPORPercVar",
    //         "QTDBudgetPORPercVar",
    //         "YTDBudgetPORPercVar",
    //         "CurrentBudgetPORPercVar",
    //         "MonthBudgetPORPercVar",
    //         "QuarterBudgetPORPercVar",
    //         "YearlyBudgetPORPercVar",
    //         "DynamicMonthBudgetPORPercVar",


    //         "PTDBudgetPORDollarVar",
    //         "QTDBudgetPORDollarVar",
    //         "YTDBudgetPORDollarVar",
    //         "CurrentBudgetPORDollarVar",
    //         "MonthBudgetPORDollarVar",
    //         "QuarterBudgetPORDollarVar",
    //         "YearlyBudgetPORDollarVar",
    //         "DynamicMonthBudgetPORDollarVar"
    //     ],
    //     "Budget PAR": [
    //         // "Budget PAR % Variance",
    //         // "Budget PAR % Variance $ Variance"
    //         "PTDBudgetPARPercVar",
    //         "QTDBudgetPARPercVar",
    //         "YTDBudgetPARPercVar",
    //         "CurrentBudgetPARPercVar",
    //         "MonthBudgetPARPercVar",
    //         "QuarterBudgetPARPercVar",
    //         "YearlyBudgetPARPercVar",
    //         "DynamicMonthBudgetPARPercVar",

    //         "PTDBudgetPARDollarVar",
    //         "QTDBudgetPARDollarVar",
    //         "YTDBudgetPARDollarVar",
    //         "CurrentBudgetPARDollarVar",
    //         "MonthBudgetPARDollarVar",
    //         "QuarterBudgetPARDollarVar",
    //         "YearlyBudgetPARDollarVar",
    //         "DynamicMonthBudgetPARDollarVar"

    //     ],
    //     "Forecast POR": [
    //         // "Forecast POR % Variance",
    //         // "Forecast POR % Variance $ Variance"
    //         "PTDForecastPORPercVar",
    //         "QTDForecastPORPercVar",
    //         "YTDForecastPORPercVar",
    //         "CurrentForecastPORPercVar",
    //         "MonthForecastPORPercVar",
    //         "QuarterForecastPORPercVar",
    //         "YearlyForecastPORPercVar",
    //         "DynamicMonthForecastPORPercVar",

    //         "PTDForecastPORDollarVar",
    //         "QTDForecastPORDollarVar",
    //         "YTDForecastPORDollarVar",
    //         "CurrentForecastPORDollarVar",
    //         "MonthForecastPORDollarVar",
    //         "QuarterForecastPORDollarVar",
    //         "YearlyForecastPORDollarVar",
    //         "DynamicMonthForecastPORDollarVar"

    //     ],
    //     "Forecast PAR": [
    //         // "Forecast PAR % Variance",
    //         // "Forecast PAR % Variance $ Variance"
    //         "PTDForecastPARPercVar",
    //         "QTDForecastPARPercVar",
    //         "YTDForecastPARPercVar",
    //         "CurrentForecastPARPercVar",
    //         "MonthForecastPARPercVar",
    //         "QuarterForecastPARPercVar",
    //         "YearlyForecastPARPercVar",
    //         "DynamicMonthForecastPARPercVar",

    //         "PTDForecastPARDollarVar",
    //         "QTDForecastPARDollarVar",
    //         "YTDForecastPARDollarVar",
    //         "CurrentForecastPARDollarVar",
    //         "MonthForecastPARDollarVar",
    //         "QuarterForecastPARDollarVar",
    //         "YearlyForecastPARDollarVar",
    //         "DynamicMonthForecastPARDollarVar"


    //     ]
    //     // add more parents here
    // };
    // const DollarAndPerVarKeys = {

    //     PTDLYDollarVar: ["PTDLYPercVar"],
    //     PTDBudgetDollarVar:["PTDBudgetPercVar"],
    //     PTDLYPARDollarVar:["PTDLYPARPercVar"],
    //     PTDLYPORDollarVar:["PTDLYPORPercVar"],
    //     PTDBudgetPARDollarVar:["PTDBudgetPARPercVar"],
    //     PTDBudgetPORDollarVar:["PTDBudgetPORPercVar"],


    //     QTDLYDollarVar:["QTDLYPercVar"],
    //     QTDBudgetDollarVar:["QTDBudgetPercVar"],
    //     QTDLYPARDollarVar:["QTDLYPARPercVar"],
    //     QTDLYPORDollarVar:["QTDLYPORPercVar"],
    //     QTDBudgetPARDollarVar:["QTDBudgetPARPercVar"],
    //     QTDBudgetPORDollarVar:["QTDBudgetPORPercVar"],

    //     YTDLYDollarVar:["YTDLYPercVar"],
    //     YTDBudgetDollarVar:["YTDBudgetPercVar"],
    //     YTDLYPARDollarVar:["YTDLYPARPercVar"],
    //     YTDLYPORDollarVar:["YTDLYPORPercVar"],
    //     YTDBudgetPARDollarVar:["YTDBudgetPARPercVar"],
    //     YTDBudgetPORDollarVar:["YTDBudgetPORPercVar"],

    //     CurrentLYDollarVar:["CurrentLYPercVar"],
    //     CurrentBudgetDollarVar:["CurrentBudgetPercVar"],
    //     CurrentLYPARDollarVar:["CurrentLYPARPercVar"],
    //     CurrentLYPORDollarVar:["CurrentLYPORPercVar"],
    //     CurrentBudgetPARDollarVar:["CurrentBudgetPARPercVar"],
    //     CurrentBudgetPORDollarVar:["CurrentBudgetPORPercVar"],

    //     MonthLYDollarVar:["MonthLYPercVar"],
    //     MonthBudgetDollarVar:["MonthBudgetPercVar"],
    //     MonthLYPARDollarVar:["MonthLYPARPercVar"],
    //     MonthLYPORDollarVar:["MonthLYPORPercVar"],
    //     MonthBudgetPARDollarVar:["MonthBudgetPARPercVar"],
    //     MonthBudgetPORDollarVar:["MonthBudgetPORPercVar"],

    //     QuarterLYDollarVar:["QuarterLYPercVar"],
    //     QuarterBudgetDollarVar:["QuarterBudgetPercVar"],
    //     QuarterLYPARDollarVar:["QuarterLYPARPercVar"],
    //     QuarterLYPORDollarVar:["QuarterLYPORPercVar"],
    //     QuarterBudgetPARDollarVar:["QuarterBudgetPARPercVar"],
    //     QuarterBudgetPORDollarVar:["QuarterBudgetPORPercVar"],

    //     YearlyLYDollarVar:["YearlyLYPercVar"],
    //     YearlyBudgetDollarVar:["YearlyBudgetPercVar"],
    //     YearlyLYPARDollarVar:["YearlyLYPARPercVar"],
    //     YearlyLYPORDollarVar:["YearlyLYPORPercVar"],
    //     YearlyBudgetPARDollarVar:["YearlyBudgetPARPercVar"],
    //     YearlyBudgetPORDollarVar:["YearlyBudgetPORPercVar"],

    //     DynamicMonthLYDollarVar:["DynamicMonthLYPercVar"],
    //     DynamicMonthBudgetDollarVar:["DynamicMonthBudgetPercVar"],
    //     DynamicMonthLYPARDollarVar:["DynamicMonthLYPARPercVar"],
    //     DynamicMonthLYPORDollarVar:["DynamicMonthLYPORPercVar"],
    //     DynamicMonthBudgetPARDollarVar:["DynamicMonthBudgetPARPercVar"],
    //     DynamicMonthBudgetPORDollarVar:["DynamicMonthBudgetPORPercVar"]
    // };
    // const [activeCollapse, setActiveCollapse] = useState(null);

    const PERIODS = [
        "PTD",
        "QTD",
        "YTD",
        "Current",
        "Month",
        "Quarter",
        "Yearly",
        "DynamicMonth",
    ];

    const COMPARISONS = [
        "LY",
        "Budget",
        "Forecast",
    ];

    const VARIANTS = [
        "",
        "PAR",
        "POR",
    ];

    const DollarAndPerVarKeys = {};

    PERIODS.forEach(period => {
        COMPARISONS.forEach(comparison => {
            VARIANTS.forEach(variant => {
                const prefix = `${period}${comparison}${variant}`;

                const dollarKey = `${prefix}DollarVar`;
                const percentKey = `${prefix}PercVar`;

                DollarAndPerVarKeys[dollarKey] = [percentKey];
            });
        });
    });

    const createParentChildMap = () => {
        const map = {};

        PERIODS.forEach(period => {
            COMPARISONS.forEach(comparison => {
                VARIANTS.forEach(variant => {
                    if (!variant) return;

                    const parentDbName = `${period}${comparison}${variant}`;

                    map[parentDbName] = [
                        `${parentDbName}PercVar`,
                        `${parentDbName}DollarVar`,
                    ];
                });
            });
        });

        return map;
    };

    const PARENT_CHILD_MAP = createParentChildMap();

    const getLast10Years = () => {
        if (!values?.dateRange?.[0]) return [];

        const startDate = new Date(values.dateRange[0]);
        if (isNaN(startDate.getTime())) return [];

        const baseYear = startDate.getFullYear() - 1;

        return Array.from({ length: 10 }, (_, i) => baseYear - i);
    };

    useEffect(() => {

        // if (values.statementType === 1) {
        if (values.statementType === 1 || values.statementType === 3) {
            const combined = reportConfiguration.columnTypes.find(item => item.displayId === 6);
            setFieldValue("columnsBy", combined)
        }

    }, [values.statementType])


    useEffect(() => {
        const years = getLast10Years();
        if (!years.length) return;

        const updated = values.columnSelections?.map(s =>
            s.selectedColumn === "LY"
                ? { ...s, year: years[0] }
                : s
        );

        setFieldValue("columnSelections", updated);
    }, [values.dateRange]);

    const selectedColumnsConfigs = reportConfiguration.columnsList.filter(
        col => col.displayId === values.columnsBy.displayId
    );


    useEffect(() => {
        // if (state?.userSelections) return;
        if (values?.columnSelections.length > 0) return;
        if (values.isMainTabsSwitch) return;
        if (!selectedColumnsConfigs.length) return;

        const defaults = buildDefaultSelections(
            selectedColumnsConfigs,
            values.columnsBy.displayId
        );

        if (defaults.length) {
            setFieldValue("columnSelections", defaults);
        }
    }, [values.columnsBy.displayId, values?.statementType]);



    const buildDefaultSelections = (configs, displayId) => {
        const defaults = [];
        configs.forEach(config => {
            Object.values(GROUPS).forEach(group => {
                // Check main key

                const isMainEnabled = (config.firstColumn || []).some(
                    item => item.dbName === group.firstColumn && item.isDefault
                );

                if (!isMainEnabled) return;

                COLUMN_KEYS.forEach(columnKey => {

                    const list = config[columnKey] || [];
                    const years = getLast10Years();

                    const isSubMainEnabled = list.some(
                        item => item.dbName === group[columnKey] && item.isDefault
                    );

                    if (!isSubMainEnabled) return;

                    list.forEach(item => {
                        if (item.isDefault) {
                            defaults.push({
                                displayId,
                                columnId: config.columnId,
                                columnName: config.columnName,
                                columnKey,
                                selectedColumn: item.displayName,
                                dbName: item.dbName,
                                // ...(item.displayName === "LY"
                                //     ? { year: new Date().getFullYear() - 1 }
                                //     : {}),
                                ...(item.displayName === "LY"
                                    ? { year: item.year ? item.year : years[0] }
                                    : {}),

                            });
                        }
                    });
                });
            })

        });

        return defaults;
    };



    const NumericInput = ({ name, isDisable, width = 60, maxValue, resetValue, errorMessage }) => {
        const ref = useRef(null);
        return (
            <input
                disabled={Boolean(isDisable)}
                ref={ref}
                defaultValue={values?.dynamicMonthlyFilter?.[name.split(".").pop()] ?? ""}
                type="text"
                inputMode="numeric"
                autoComplete="off"
                onChange={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                }}
                // onBlur={(e) => {
                //     setFieldValue(name, e.target.value);
                // }}
                onBlur={(e) => {
                    let value = Number(e.target.value);

                    if (
                        maxValue !== undefined &&
                        value > maxValue
                    ) {
                        enqueueSnackbar(
                            errorMessage || `Please enter a value less than ${maxValue}`,
                            { variant: "warning" }
                        );

                        value = resetValue ?? "";
                        e.target.value = value;
                    }

                    setFieldValue(name, value);
                }}
                style={{
                    width,
                    height: 25,
                    fontSize: 11,
                    padding: "0 6px",
                    borderRadius: "3px",
                }}
            />
        );
    };

    // const ColumnGroup = ({
    //     list = [],
    //     displayId,
    //     columnName,
    //     columnKey,
    //     columnId
    // }) => {
    //     if (!list.length) return null;

    //     const selections = values.columnSelections || [];

    //     const parentSelected = selections.some(
    //         s =>
    //             s.displayId === displayId &&
    //             s.selectedColumn === columnName
    //     );
    //     const isDynamicMonthly =
    //         values.columnsBy.displayName === "DynamicMonthly" &&
    //         columnKey === "firstColumn";

    //     const dynamicFilterEnabled = parentSelected;

    //     // check if THIS column's first item is selected
    //     const firstItemName = list[0]?.displayName;

    //     const columnActivated = selections.some(
    //         s =>
    //             s.displayId === displayId &&
    //             s.columnName === columnName &&
    //             s.columnKey === columnKey &&
    //             s.selectedColumn === firstItemName
    //     );
    //     const years = getLast10Years();

    //     const selectedLY = selections.find(
    //         s =>
    //             s.displayId === displayId &&
    //             // s.columnName === columnName &&
    //             // s.columnKey === columnKey &&
    //             s.selectedColumn === "LY"
    //     );

    //     const updateLYYearForAll = (year) => {
    //         const updated = values.columnSelections.map(s =>
    //             s.selectedColumn === "LY" &&
    //                 s.displayId === displayId
    //                 ? { ...s, year }
    //                 : s
    //         );

    //         setFieldValue("columnSelections", updated);
    //     };


    //     const handleSelect = (name, dbName) => {
    //         const exists = selections.find(
    //             s =>
    //                 s.displayId === displayId &&
    //                 s.columnName === columnName &&
    //                 s.columnKey === columnKey &&
    //                 s.selectedColumn === name
    //         );


    //         if (exists) {
    //             let updated = selections.filter(s => s !== exists);

    //             // if parent removed → clear everything
    //             if (name === columnName) {
    //                 updated = updated.filter(
    //                     s =>
    //                         !(
    //                             s.displayId === displayId &&
    //                             s.columnName === columnName
    //                         )
    //                 );
    //                 setFieldValue("dynamicMonthlyFilter", {
    //                     actualForCompletedMonths: false,
    //                     actualMonths: 0,
    //                     monthType: "following",
    //                     foreCasteForNext: false,
    //                     onlyBudgetMonths: false
    //                 });
    //             }

    //             // if first item removed → remove whole column
    //             if (name === firstItemName) {
    //                 updated = updated.filter(
    //                     s =>
    //                         !(
    //                             s.displayId === displayId &&
    //                             s.columnName === columnName &&
    //                             s.columnKey === columnKey
    //                         )
    //                 );
    //             }

    //             // remove child groups (LY PAR / LY POR)
    //             if (PARENT_CHILD_MAP[name]) {
    //                 updated = updated.filter(s => {
    //                     return !PARENT_CHILD_MAP[name].includes(s.dbName);
    //                 });
    //             }

    //             // remove all related PAR/POR children
    //             if (
    //                 columnKey === "firstColumn" &&
    //                 (name === "PAR" || name === "POR")
    //             ) {

    //                 const relatedParentKeys = Object.keys(PARENT_CHILD_MAP)
    //                     .filter(key => key.includes(name));

    //                 const relatedChildDbNames = Object.entries(PARENT_CHILD_MAP)
    //                     .filter(([key]) => key.includes(name))
    //                     .flatMap(([_, values]) => values);

    //                 updated = updated.filter(
    //                     s =>
    //                         !relatedChildDbNames.includes(s.dbName) &&
    //                         !relatedParentKeys.includes(s.selectedColumn)
    //                 );
    //             }
    //             // If a main option is removed, remove its dependent options for $ var and % var
    //             const dependentOptions = DollarAndPerVarKeys[dbName] || [];

    //             if (dependentOptions.length > 0) {
    //                 updated = updated.filter(
    //                     s =>
    //                         !(
    //                             s.displayId === displayId &&
    //                             s.columnName === columnName &&
    //                             s.columnKey === columnKey &&
    //                             dependentOptions.includes(s.dbName)
    //                         )
    //                 );
    //             }

    //             setFieldValue("columnSelections", updated);
    //         }

    //         // ADD
    //         else {
    //             const existingLY = selections.find(
    //                 s =>
    //                     s.selectedColumn === "LY" &&
    //                     s.displayId === displayId &&
    //                     s.columnName === columnName &&
    //                     s.columnKey === columnKey
    //             );
    //             setFieldValue("columnSelections", [
    //                 ...selections,
    //                 {
    //                     displayId,
    //                     columnId: columnId,
    //                     columnName,
    //                     columnKey,
    //                     selectedColumn: name,
    //                     dbName,
    //                     ...(name === "LY"
    //                         ? { year: existingLY?.year || years[0] }
    //                         : {}),
    //                 },
    //             ]);
    //         }

    //     };


    //     // FOR PAR/POR  handling
    //     const firstColumnSelections = selections.filter(
    //         s =>
    //             s.displayId === displayId &&
    //             s.columnKey === "firstColumn"
    //     );
    //     const enabledParentNames = firstColumnSelections
    //         .filter(s => s.columnName === columnName)
    //         .map(s => s.selectedColumn);

    //     const allowedChildDbNames = Object.entries(PARENT_CHILD_MAP)
    //         .filter(([key]) =>
    //             enabledParentNames.some(parent =>
    //                 key.includes(parent)
    //             )
    //         )
    //         .flatMap(([_, values]) => values);

    //     // To get defeault values of actualMonths, forecastMonths when Dynamic monthly
    //     // const dynamicMonthData = reportConfiguration.columnsList?.find(
    //     //     col => col.displayId === Object.values(reportConfiguration.columnTypes || {}).find(
    //     //         item => item.displayName === "DynamicMonthly")?.displayId)?.firstColumn
    //     //     ?.find(
    //     //         item => item.dbName === "DynamicMonth"
    //     //     );

    //     // const actualMonths = dynamicMonthData?.monthActualDays ?? 15;
    //     // const forecastMonths = dynamicMonthData?.forecastMonths ?? 4;
    //     const { actualMonths, forecastMonths } = getDynamicMonthlyDefaults();



    //     return (
    //         <Stack gap={1}>


    //             {list.map((item, index) => {

    //                 const name = item.displayName;
    //                 const dbName = item.dbName;
    //                 // if (
    //                 //     values.columnsBy.displayName === "DynamicMonthly" &&
    //                 //     dynimicMontlyPARandPOR.includes(dbName)
    //                 // ) {
    //                 //     return null;
    //                 // }

    //                 const isMainParent = name === columnName;
    //                 const isFirstItem = index === 0;

    //                 // child-parent (LY PAR / LY POR)
    //                 const parentOfChild = Object.entries(PARENT_CHILD_MAP)
    //                     .find(([_, children]) => children.includes(dbName))?.[0];

    //                 const childParentSelected = selections.some(
    //                     s =>
    //                         s.displayId === displayId &&
    //                         s.columnName === columnName &&
    //                         s.columnKey === columnKey &&
    //                         s.selectedColumn === parentOfChild
    //                 );

    //                 if (parentOfChild && !childParentSelected) return null;

    //                 const isSelected = selections.some(
    //                     s =>
    //                         s.displayId === displayId &&
    //                         s.columnName === columnName &&
    //                         s.columnKey === columnKey &&
    //                         s.selectedColumn === name
    //                 );

    //                 // ENABLE / DISABLE RULES
    //                 let disabled = true;

    //                 if (isMainParent) {
    //                     disabled = false;
    //                 } else if (parentSelected && isFirstItem) {
    //                     disabled = false;
    //                 }
    //                 else if (columnActivated) {
    //                     disabled = false;

    //                 }
    //                 // if (columnKey !== "firstColumn" && values.columnsBy.displayName !== "DynamicMonthly") {

    //                 // MAIN PAR/POR Disable/Enable conditions
    //                 const isParPorParent = Object.keys(PARENT_CHILD_MAP).includes(name);
    //                 if (isParPorParent && !disabled) {
    //                     disabled = !enabledParentNames.some(parent =>
    //                         name.includes(parent)
    //                     );
    //                 }
    //                 if (parentOfChild) {
    //                     disabled = !allowedChildDbNames.includes(dbName);
    //                 }
    //                 // Check whether this option depends on another option
    //                 const dependentParent = Object.entries(DollarAndPerVarKeys)
    //                     .find(([parentDbName, dependentDbNames]) =>
    //                         dependentDbNames.includes(dbName)
    //                     )?.[0];

    //                 if (dependentParent) {
    //                     const isParentSelected = selections.some(
    //                         s =>
    //                             s.displayId === displayId &&
    //                             s.columnName === columnName &&
    //                             s.columnKey === columnKey &&
    //                             s.dbName === dependentParent
    //                     );

    //                     if (!isParentSelected) {
    //                         disabled = true;
    //                     }
    //                 }

    //                 return (
    //                     <Stack
    //                         key={name}
    //                         gap={0.5}
    //                         ml={parentOfChild ? 2 : 0}
    //                     >
    //                         {/* MAIN OPTION */}
    //                         <div
    //                             style={{
    //                                 marginLeft: parentOfChild ? 16 : 0,
    //                                 display: "flex",
    //                                 alignItems: "center",
    //                                 gap: 8,
    //                             }}
    //                         >
    //                             {/* <CustomOptions
    //                                 type={name}
    //                                 selected={isSelected}
    //                                 disabled={disabled}
    //                                 onClick={() => handleSelect(name, dbName)}
    //                             /> */}
    //                             {dbName !== "DynamicMonth" && (
    //                                 <CustomOptions
    //                                     type={name}
    //                                     selected={isSelected}
    //                                     disabled={disabled}
    //                                     onClick={() => handleSelect(name, dbName)}
    //                                 />
    //                             )}


    //                             {/* LY YEAR DROPDOWN */}
    //                             {name === "LY" && isSelected && !disabled && (
    //                                 <select
    //                                     value={selectedLY?.year || years[0]}
    //                                     onChange={(e) => {
    //                                         updateLYYearForAll(Number(e.target.value));
    //                                     }}
    //                                     style={{
    //                                         height: 20,
    //                                         fontSize: 11,
    //                                         padding: "0 6px",
    //                                         borderRadius: "3px"
    //                                     }}
    //                                 >
    //                                     {years.map(y => (
    //                                         <option key={y} value={y}>
    //                                             {y}
    //                                         </option>
    //                                     ))}
    //                                 </select>
    //                             )}
    //                         </div>

    //                         {/* 🔹 DynamicMonthly FILTER — BELOW MAIN PARENT */}
    //                         {isDynamicMonthly && isMainParent && (
    //                             <Stack direction="column" gap={2.5} flexWrap={"wrap"} >

    //                                 <CustomOptions
    //                                     type="Only Actuals for completed months (except total)"
    //                                     selected={!!values.dynamicMonthlyFilter?.actualForCompletedMonths}
    //                                     // disabled={!dynamicFilterEnabled}
    //                                     onClick={() => {
    //                                         handleSelect(name, dbName)
    //                                         setFieldValue("dynamicMonthlyFilter", {
    //                                             ...(values.dynamicMonthlyFilter || {}),
    //                                             actualForCompletedMonths:
    //                                                 !values.dynamicMonthlyFilter?.actualForCompletedMonths,
    //                                             monthType: "following",

    //                                             foreCasteForNext: !values.dynamicMonthlyFilter?.foreCasteForNext,
    //                                             onlyBudgetMonths: !values.dynamicMonthlyFilter?.onlyBudgetMonths,
    //                                             actualMonths: actualMonths,
    //                                             monthsCount: forecastMonths,
    //                                         });
    //                                     }}
    //                                     width={400}
    //                                 />

    //                                 {/* {values.dynamicMonthlyFilter?.actualForCompletedMonths && */}

    //                                 <Stack direction={"row"} alignItems={"center"} gap={0.5}>
    //                                     <Typography noWrap fontSize={12}>
    //                                         Consider month actuals once
    //                                     </Typography>
    //                                     <NumericInput
    //                                         name="dynamicMonthlyFilter.actualMonths"
    //                                         // value={values.dynamicMonthlyFilter.actualMonths}
    //                                         isDisable={!dynamicFilterEnabled}
    //                                         maxValue={25}
    //                                         resetValue={15}
    //                                         errorMessage="Please enter less than 25 Numbers."
    //                                     />

    //                                     <Typography noWrap fontSize={12}>
    //                                         days completed in
    //                                     </Typography>
    //                                     <select
    //                                         value={values.dynamicMonthlyFilter.monthType}
    //                                         onChange={(e) =>
    //                                             setFieldValue("dynamicMonthlyFilter.monthType", e.target.value)
    //                                         }
    //                                         style={{
    //                                             height: 20,
    //                                             fontSize: 11,
    //                                             padding: "0 6px",
    //                                             borderRadius: "3px",
    //                                         }}
    //                                     >
    //                                         <option value="following">Following</option>
    //                                         <option value="current">Current</option>
    //                                     </select>
    //                                     <Typography noWrap fontSize={12}>
    //                                         month
    //                                     </Typography>

    //                                 </Stack>
    //                                 {/* Released for next version, so keeping it commented for now. Will be added in future if needed. */}
    //                                 {/* <Stack direction={"row"} justifyContent={"space-between"} flexWrap={"wrap"} alignItems={"center"}>
    //                                     <CustomOptions
    //                                         type="Forecast for next"
    //                                         selected={!!values.dynamicMonthlyFilter?.foreCasteForNext}
    //                                         disabled={!dynamicFilterEnabled}
    //                                     />
    //                                     <Stack direction={"row"} gap={2} alignItems={"center"}>

    //                                         <NumericInput
    //                                             name="dynamicMonthlyFilter.monthsCount"
    //                                             // value={values.dynamicMonthlyFilter.monthsCount}
    //                                             isDisable={!dynamicFilterEnabled}
    //                                             maxValue={12}
    //                                             resetValue={4}
    //                                             errorMessage="Please enter less than 12 Numbers."
    //                                         />


    //                                         <Typography noWrap fontSize={12}>
    //                                             Months
    //                                         </Typography>
    //                                     </Stack>
    //                                 </Stack> */}

    //                                 <CustomOptions
    //                                     type="Only Budget for remain months (except total)"
    //                                     selected={!!values.dynamicMonthlyFilter?.onlyBudgetMonths}
    //                                     disabled={!dynamicFilterEnabled}
    //                                     onClick={() => {
    //                                         setFieldValue(
    //                                             "dynamicMonthlyFilter.onlyBudgetMonths",
    //                                             // !values.dynamicMonthlyFilter?.onlyBudgetMonths
    //                                             true
    //                                         );


    //                                     }}
    //                                     width={400}
    //                                 />


    //                             </Stack>
    //                         )}


    //                     </Stack>
    //                 );


    //             })}

    //         </Stack>
    //     );
    // };


    const ColumnGroup = ({
        list = [],
        displayId,
        columnName,
        columnKey,
        columnId
    }) => {
        if (!list.length) return null;

        const selections = values.columnSelections || [];

        const mainParentSelection = selections.find(
            s =>
                s.displayId === displayId &&
                s.columnName === columnName &&
                s.selectedColumn === columnName
        );

        const mainParentDbName = mainParentSelection?.dbName;

        const firstItemDbName = list[0]?.dbName;

        const lyDbName = list.find(
            item => item.displayName === "LY"
        )?.dbName;

        const parentSelected = selections.some(
            s =>
                s.displayId === displayId &&
                // s.columnName === columnName &&
                s.dbName === mainParentDbName
                &&
                mainParentDbName != null
        );

        const isDynamicMonthly =
            values.columnsBy.displayName === "DynamicMonthly" &&
            columnKey === "firstColumn";

        const dynamicFilterEnabled = parentSelected;

        const columnActivated = selections.some(
            s =>
                s.displayId === displayId &&
                s.columnName === columnName &&
                s.columnKey === columnKey &&
                s.dbName === firstItemDbName
        );

        const years = getLast10Years();

        const selectedLY = selections.find(
            s =>
                s.displayId === displayId &&
                s.dbName === lyDbName
        );

        const updateLYYearForAll = (year) => {
            const updated = values.columnSelections.map(s =>
                s.selectedColumn === "LY" &&
                    s.displayId === displayId
                    ? { ...s, year }
                    : s
            );

            setFieldValue("columnSelections", updated);
        };

        const handleSelect = (name, dbName) => {
            const exists = selections.find(
                s =>
                    s.displayId === displayId &&
                    s.columnName === columnName &&
                    s.columnKey === columnKey &&
                    s.dbName === dbName
            );

            if (exists) {
                let updated = selections.filter(
                    s => s !== exists
                );

                // Remove the main parent and all its options.
                if (dbName === mainParentDbName) {
                    updated = updated.filter(
                        s =>
                            !(
                                s.displayId === displayId &&
                                s.columnName === columnName
                            )
                    );

                    setFieldValue("dynamicMonthlyFilter", {
                        actualForCompletedMonths: false,
                        actualMonths: 0,
                        monthType: "following",
                        foreCasteForNext: false,
                        onlyBudgetMonths: false
                    });
                }

                // Remove the entire column when its first DB option is removed.
                if (dbName === firstItemDbName) {
                    updated = updated.filter(
                        s =>
                            !(
                                s.displayId === displayId &&
                                s.columnName === columnName &&
                                s.columnKey === columnKey
                            )
                    );
                }

                // Remove direct children of this DB option.
                const childDbNames = PARENT_CHILD_MAP[dbName] || [];

                if (childDbNames.length > 0) {
                    updated = updated.filter(
                        s => !childDbNames.includes(s.dbName)
                    );
                }

                // Remove related PAR/POR parent-child options dynamically.
                if (
                    columnKey === "firstColumn" &&
                    /(PAR|POR)$/.test(dbName)
                ) {
                    const variant = dbName.match(/(PAR|POR)$/)?.[0];

                    const relatedParentKeys = Object.keys(PARENT_CHILD_MAP)
                        .filter(key => key.endsWith(variant));

                    const relatedChildDbNames = relatedParentKeys.flatMap(
                        key => PARENT_CHILD_MAP[key]
                    );

                    updated = updated.filter(
                        s =>
                            !relatedChildDbNames.includes(s.dbName) &&
                            !relatedParentKeys.includes(s.dbName)
                    );
                }

                // Remove dependent dollar/percentage options.
                const dependentOptions = DollarAndPerVarKeys[dbName] || [];

                if (dependentOptions.length > 0) {
                    updated = updated.filter(
                        s =>
                            !(
                                s.displayId === displayId &&
                                s.columnName === columnName &&
                                s.columnKey === columnKey &&
                                dependentOptions.includes(s.dbName)
                            )
                    );
                }

                setFieldValue("columnSelections", updated);
            } else {
                const existingLY = selections.find(
                    s =>
                        s.displayId === displayId &&
                        s.columnName === columnName &&
                        s.columnKey === columnKey &&
                        s.dbName === lyDbName
                );

                setFieldValue("columnSelections", [
                    ...selections,
                    {
                        displayId,
                        columnId,
                        columnName,
                        columnKey,
                        selectedColumn: name,
                        dbName,
                        ...(dbName === lyDbName
                            ? { year: existingLY?.year || years[0] }
                            : {})
                    }
                ]);
            }
        };


        const firstColumnSelections = selections.filter(
            s =>
                s.displayId === displayId &&
                s.columnKey === "firstColumn"
        );

        const enabledParentNames = firstColumnSelections
            .filter(s => s.columnName === columnName)
            .map(s => s.dbName);

        // Find all children matching the enabled parent's period and variant.
        const allowedChildDbNames = Object.entries(PARENT_CHILD_MAP)
            .filter(([key]) => {
                const keyVariant = key.match(/(PAR|POR)$/)?.[0];
                const keyPeriod = PERIODS.find(
                    period => key.startsWith(period)
                );

                return enabledParentNames.some(parent => {
                    const parentVariant = parent.match(/(PAR|POR)$/)?.[0];
                    const parentPeriod = PERIODS.find(
                        period => parent.startsWith(period)
                    );

                    return (
                        parentVariant === keyVariant &&
                        parentPeriod === keyPeriod
                    );
                });
            })
            .flatMap(([, children]) => children);

        const { actualMonths, forecastMonths } = getDynamicMonthlyDefaults();


        return (
            <Stack gap={1}>


                {list.map((item, index) => {

                    const name = item.displayName;
                    const dbName = item.dbName;

                    // const isMainParent = dbName === mainParentDbName;
                    const isMainParent = name === columnName;
                    const isFirstItem = index === 0;

                    const parentOfChild = Object.entries(PARENT_CHILD_MAP)
                        .find(([, children]) => children.includes(dbName))?.[0];

                    const childParentSelected = selections.some(
                        s =>
                            s.displayId === displayId &&
                            s.columnName === columnName &&
                            s.columnKey === columnKey &&
                            s.dbName === parentOfChild
                    );

                    if (parentOfChild && !childParentSelected) {
                        return null;
                    }

                    const isSelected = selections.some(
                        s =>
                            s.displayId === displayId &&
                            s.columnName === columnName &&
                            s.columnKey === columnKey &&
                            s.dbName === dbName
                    );

                    let disabled = true;

                    if (isMainParent) {
                        disabled = false;
                    } else if (parentSelected && isFirstItem) {
                        disabled = false;
                    } else if (columnActivated) {
                        disabled = false;
                    }

                    // MAIN PAR/POR Disable/Enable conditions
                    const isParPorParent = Object.prototype.hasOwnProperty.call(
                        PARENT_CHILD_MAP,
                        dbName
                    );

                    if (isParPorParent && !disabled) {
                        const parentVariant = dbName.match(/(PAR|POR)$/)?.[0];
                        const parentPeriod = PERIODS.find(
                            period => dbName.startsWith(period)
                        );

                        disabled = !enabledParentNames.some(parent => {
                            const enabledVariant = parent.match(/(PAR|POR)$/)?.[0];
                            const enabledPeriod = PERIODS.find(
                                period => parent.startsWith(period)
                            );

                            return (
                                enabledVariant === parentVariant &&
                                enabledPeriod === parentPeriod
                            );
                        });
                    }

                    if (parentOfChild) {
                        disabled = !allowedChildDbNames.includes(dbName);
                    }

                    // Check whether this option depends on another option % and $ var options
                    const dependentParent = Object.entries(DollarAndPerVarKeys)
                        .find(([, dependentDbNames]) =>
                            dependentDbNames.includes(dbName)
                        )?.[0];

                    if (dependentParent) {
                        const isParentSelected = selections.some(
                            s =>
                                s.displayId === displayId &&
                                s.columnName === columnName &&
                                s.columnKey === columnKey &&
                                s.dbName === dependentParent
                        );

                        if (!isParentSelected) {
                            disabled = true;
                        }
                    }

                    return (
                        <Stack
                            key={name}
                            gap={0.5}
                            ml={parentOfChild ? 2 : 0}
                        >
                            {/* MAIN OPTION */}
                            <div
                                style={{
                                    marginLeft: parentOfChild ? 16 : 0,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                }}
                            >
                                {/* <CustomOptions
                                    type={name}
                                    selected={isSelected}
                                    disabled={disabled}
                                    onClick={() => handleSelect(name, dbName)}
                                /> */}
                                {dbName !== "DynamicMonth" && (
                                    <CustomOptions
                                        type={name}
                                        selected={isSelected}
                                        disabled={disabled}
                                        onClick={() => handleSelect(name, dbName)}
                                    />
                                )}


                                {/* LY YEAR DROPDOWN */}
                                {name === "LY" && isSelected && !disabled && (
                                    <select
                                        value={selectedLY?.year || years[0]}
                                        onChange={(e) => {
                                            updateLYYearForAll(Number(e.target.value));
                                        }}
                                        style={{
                                            height: 20,
                                            fontSize: 11,
                                            padding: "0 6px",
                                            borderRadius: "3px"
                                        }}
                                    >
                                        {years.map(y => (
                                            <option key={y} value={y}>
                                                {y}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </div>

                            {/* 🔹 DynamicMonthly FILTER — BELOW MAIN PARENT */}
                            {isDynamicMonthly && isMainParent && (
                                <Stack direction="column" gap={2.5} flexWrap={"wrap"} >

                                    <CustomOptions
                                        type="Only Actuals for completed months (except total)"
                                        selected={!!values.dynamicMonthlyFilter?.actualForCompletedMonths}
                                        // disabled={!dynamicFilterEnabled}
                                        onClick={() => {
                                            handleSelect(name, dbName)
                                            setFieldValue("dynamicMonthlyFilter", {
                                                ...(values.dynamicMonthlyFilter || {}),
                                                actualForCompletedMonths:
                                                    !values.dynamicMonthlyFilter?.actualForCompletedMonths,
                                                monthType: "following",

                                                foreCasteForNext: !values.dynamicMonthlyFilter?.foreCasteForNext,
                                                onlyBudgetMonths: !values.dynamicMonthlyFilter?.onlyBudgetMonths,
                                                actualMonths: actualMonths,
                                                monthsCount: forecastMonths,
                                            });
                                        }}
                                        width={400}
                                    />

                                    {/* {values.dynamicMonthlyFilter?.actualForCompletedMonths && */}

                                    <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                                        <Typography noWrap fontSize={12}>
                                            Consider month actuals once
                                        </Typography>
                                        <NumericInput
                                            name="dynamicMonthlyFilter.actualMonths"
                                            // value={values.dynamicMonthlyFilter.actualMonths}
                                            isDisable={!dynamicFilterEnabled}
                                            maxValue={25}
                                            resetValue={15}
                                            errorMessage="Please enter less than 25 Numbers."
                                        />

                                        <Typography noWrap fontSize={12}>
                                            days completed in
                                        </Typography>
                                        <select
                                            value={values.dynamicMonthlyFilter.monthType}
                                            onChange={(e) =>
                                                setFieldValue("dynamicMonthlyFilter.monthType", e.target.value)
                                            }
                                            style={{
                                                height: 20,
                                                fontSize: 11,
                                                padding: "0 6px",
                                                borderRadius: "3px",
                                            }}
                                        >
                                            <option value="following">Following</option>
                                            <option value="current">Current</option>
                                        </select>
                                        <Typography noWrap fontSize={12}>
                                            month
                                        </Typography>

                                    </Stack>
                                    {/* Released for next version, so keeping it commented for now. Will be added in future if needed. */}
                                    {/* <Stack direction={"row"} justifyContent={"space-between"} flexWrap={"wrap"} alignItems={"center"}>
                                        <CustomOptions
                                            type="Forecast for next"
                                            selected={!!values.dynamicMonthlyFilter?.foreCasteForNext}
                                            disabled={!dynamicFilterEnabled}
                                        />
                                        <Stack direction={"row"} gap={2} alignItems={"center"}>

                                            <NumericInput
                                                name="dynamicMonthlyFilter.monthsCount"
                                                // value={values.dynamicMonthlyFilter.monthsCount}
                                                isDisable={!dynamicFilterEnabled}
                                                maxValue={12}
                                                resetValue={4}
                                                errorMessage="Please enter less than 12 Numbers."
                                            />


                                            <Typography noWrap fontSize={12}>
                                                Months
                                            </Typography>
                                        </Stack>
                                    </Stack> */}

                                    <CustomOptions
                                        type="Only Budget for remain months (except total)"
                                        selected={!!values.dynamicMonthlyFilter?.onlyBudgetMonths}
                                        disabled={!dynamicFilterEnabled}
                                        onClick={() => {
                                            setFieldValue(
                                                "dynamicMonthlyFilter.onlyBudgetMonths",
                                                // !values.dynamicMonthlyFilter?.onlyBudgetMonths
                                                true
                                            );


                                        }}
                                        width={400}
                                    />


                                </Stack>
                            )}


                        </Stack>
                    );


                })}

            </Stack>
        );
    };

    const getDynamicMonthlyDefaults = () => {
        const dynamicMonthData = reportConfiguration.columnsList?.find(
            col => col.displayId === Object.values(reportConfiguration.columnTypes || {}).find(
                item => item.displayName === "DynamicMonthly")?.displayId)?.firstColumn
            ?.find(
                item => item.dbName === "DynamicMonth"
            );

        return {
            actualMonths: dynamicMonthData?.monthActualDays ?? 15,
            forecastMonths: dynamicMonthData?.forecastMonths ?? 4
        };
    };

    return (
        <Stack width={"100%"} gap={1}>
            {/* {values.statementType !== 1 && */}
            {(values.statementType === 0 || values.statementType === 2) &&
                <Stack alignItems={"center"} direction={"row"} gap={2}>

                    <Typography fontSize={12}>
                        Columns by
                    </Typography>
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent={
                            reportConfiguration.columnTypes.filter(
                                item => item.displayName !== "Combine" && item.displayId !== 6
                            ).length < 2
                                ? "flex-start"
                                : "space-evenly"
                        }
                        flex={1}
                    >
                        {reportConfiguration.columnTypes.map(item => {
                            if (item.displayName === "Combine" || item.displayId === 6) return null;

                            return (
                                <OutlinedSelectButton
                                    key={item.displayId}
                                    label={item.displayName}
                                    selected={values.columnsBy.displayId === item.displayId}
                                    onClick={() => {
                                        if (values.columnsBy?.displayId === item.displayId) {
                                            return;
                                        }
                                        if (item?.displayName === "DynamicMonthly") {
                                            const { actualMonths, forecastMonths } = getDynamicMonthlyDefaults();
                                            setFieldValue("dynamicMonthlyFilter", {
                                                actualForCompletedMonths: true,
                                                actualMonths: actualMonths,
                                                monthType: "following",
                                                foreCasteForNext: "",
                                                monthsCount: forecastMonths,
                                                onlyBudgetMonths: false
                                            });
                                        } else {
                                            setFieldValue("dynamicMonthlyFilter", {
                                                actualForCompletedMonths: true,
                                                actualMonths: "",
                                                monthType: "following",
                                                foreCasteForNext: "",
                                                monthsCount: "",
                                                onlyBudgetMonths: false
                                            });

                                        }
                                        setFieldValue("columnsBy", item)
                                        setFieldValue("columnSelections", []);
                                        // setFieldValue("dynamicMonthlyFilter", {
                                        //     actualForCompletedMonths: true,
                                        //     actualMonths: "",
                                        //     monthType: "following",
                                        //     foreCasteForNext: "",
                                        //     monthsCount: "",
                                        //     onlyBudgetMonths: false
                                        // });
                                    }
                                    }
                                    width="150px"
                                />
                            );
                        })}
                    </Stack>
                </Stack>
            }

            <Stack gap={2}>
                {selectedColumnsConfigs.map((config) => {
                    const panelKey = `${config.displayId}-${config.columnName}`;

                    return (

                        (values?.statementType === 0 || values?.statementType === 2) ?

                            (
                                values?.columnsBy?.displayId === 6 ?
                                    null :
                                    values.columnsBy.displayName === "Total" ?
                                        (<Collapse
                                            bordered={true}
                                            key={panelKey}
                                            // activeKey={activeCollapse === panelKey ? "panel" : null}
                                            // onChange={(key) => {
                                            //     setActiveCollapse(key ? panelKey : null);
                                            // }}
                                            expandIcon={() => null}
                                            style={{
                                                background: "#bfe3f4",
                                                borderRadius: 5,
                                            }}
                                            items={[
                                                {
                                                    key: "panel",
                                                    label: (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                width: "100%",
                                                            }}
                                                        >
                                                            <span style={{ fontWeight: 500 }}>
                                                                {config.columnName}
                                                            </span>
                                                            <Space size={10}>
                                                                {COLUMN_KEYS.map((key) => {
                                                                    const column = values.columnSelections?.find(
                                                                        (item) =>
                                                                            item.columnKey === key &&
                                                                            item.columnId === config.columnId
                                                                    );

                                                                    return column ? (
                                                                        <Tag
                                                                            key={`${key}-${config.columnId}`}
                                                                            style={{
                                                                                backgroundColor: "#7ec0d0",
                                                                                padding: "0px 20px",
                                                                                width: 90,
                                                                                textAlign: "center",
                                                                                fontSize: 11,
                                                                            }}
                                                                        >
                                                                            {column.selectedColumn}
                                                                        </Tag>
                                                                    ) : null;
                                                                })}
                                                            </Space>
                                                        </div>
                                                    ),
                                                    children: (
                                                        <Stack gap={2} direction="row" padding={1} overflow={"auto"}>
                                                            {COLUMN_KEYS.map((key) => (
                                                                <ColumnGroup
                                                                    // key={key}
                                                                    key={config[key]["dbName"]}
                                                                    list={config[key]}
                                                                    displayId={config.displayId}
                                                                    columnName={config.columnName}
                                                                    columnKey={key}
                                                                    columnId={config.columnId}

                                                                />
                                                            ))}
                                                        </Stack>
                                                    ),
                                                },
                                            ]}
                                        />)
                                        :
                                        (<Stack gap={2} direction="row" padding={1}>
                                            {COLUMN_KEYS.map((key) => (
                                                <ColumnGroup
                                                    // key={key}
                                                    key={config[key]["dbName"]}
                                                    list={config[key]}
                                                    displayId={config.displayId}
                                                    columnName={config.columnName}
                                                    columnKey={key}
                                                    columnId={config.columnId}
                                                />
                                            ))}
                                        </Stack>)
                            )
                            :
                            (<Stack gap={2} direction="row" padding={1}>
                                {COLUMN_KEYS.map((key) => (
                                    <ColumnGroup
                                        // key={key}
                                        key={config[key]["dbName"]}
                                        list={config[key]}
                                        displayId={config.displayId}
                                        columnName={config.columnName}
                                        columnKey={key}
                                        columnId={config.columnId}
                                    />
                                ))}
                            </Stack>)

                    );
                })}
            </Stack>

        </Stack>

    )
}

export default ColumnsSettings;
